document.addEventListener("DOMContentLoaded", function () {
    new QuizWizard().init();
});

class QuizWizard {
    // Slide-type constants
    static TYPE_SINGLE_SELECT       = 'single-select';
    static TYPE_SINGLE_DECISION     = 'single-decision';
    static TYPE_MULTI_SELECT        = 'multi-select';
    static TYPE_TEXT_ANSWER         = 'text-answer';
    static TYPE_EMAIL_COLLECTION    = 'email-collection';
    static TYPE_SLIDER              = 'slider';
    static TYPE_HEIGHT_WEIGHT       = 'height-weight';
    static TYPE_WEIGHT              = 'weight';
    static TYPE_FINAL_PAGE          = 'final-page';

    static DEBUG                    = true;
    static OUTBOUND_CLICK_DELAY     = 1; // How long we will delay the link clicking to let all the handlers send the data

    static OUTBOUND_TYPE_FINAL      = 'final CTA';
    static OUTBOUND_TYPE_SECONDARY  = 'secondary CTA';

    constructor() {
        // Element refs
        this.mainDiv     = document.getElementById('quiz-wizard'); // Main div, contains global settings in data attributes
        this.nextBtn     = document.getElementById('quiz-next');
        this.backBtn     = document.getElementById('quiz-back');
        this.destCTA     = document.getElementById('quiz-dest-button'); // Secondary nav button, styled as a link, below the Next button
        this.progressBar = document.querySelector('.quiz-progress');
        this.footer      = document.getElementById('quiz-footer');

        // Slides
        const all = Array.from(document.querySelectorAll('.quiz-slide'));
        this.slides = all.filter(s => s.dataset.slideType !== QuizWizard.TYPE_FINAL_PAGE);
        this.finals = all.filter(s => s.dataset.slideType === QuizWizard.TYPE_FINAL_PAGE);
        this.finalPages = this.finals.reduce((map, s) => {
            const id = s.dataset.finalId;
            (map[id] = map[id]||[]).push(s);
            return map;
        }, {});

        // State & flags
        this.currentStep        = 0;
        this.submissionComplete = false; // if the quiz was fully completed, i.e. the final step has been reached
        this.exitPayloadSent    = false; // tells whether the payload has been sent
        this.isUserInput        = false; // this flag says if the user gave any answers. If not, then no data is saved
        this.finalPageId        = '';
        this.shopifyTemplate    = this.mainDiv.dataset.shopifyTemplate;
        this.SAVE_PROGRESS      = !!this.mainDiv.dataset.saveProgress;
        this.QUIZ_STORAGE_KEY   = 'quizWizardState_v2-'+this.shopifyTemplate;
        this.WEBAPP_URL         = `https://script.google.com/macros/s/${this.mainDiv.dataset.exportUrl}/exec`;
        this.isInEditor         = this.mainDiv.dataset.inEditor === 'true';
        this.isEmailSubmitted   = false;

        // Quiz analytics
        this.outboundUrl        = null;
        this.outboundButton     = null;
        this.utmSource          = 'quiz';
        this.utmCampaign        = this.shopifyTemplate;
        this.userEmail          = null;

        // Klaviyo settings
        this.klaviyoCompanyId       = this.mainDiv.dataset.klaviyoCompanyId;
        this.klaviyoListId          = this.mainDiv.dataset.klaviyoListId;
        this.klaviyoMarketingEvent  = this.mainDiv.dataset.klaviyoMarketingEvent

    }

  // Registry of behaviors per slide type
    static slideTypes = {
        [QuizWizard.TYPE_SINGLE_SELECT]: {
            validate(slide) {
                return !!slide.querySelector('input[type="radio"]:checked');    // One of the radios must be checked
            },
            extract(slide) {
                const sel = slide.querySelector('input[type="radio"]:checked'); // The value of the radio checked
                return sel ? sel.value : '';
            },
            hydrate(slide, value) {
                if (value == null) return;
                slide.querySelectorAll('input[type="radio"]').forEach(r => {
                r.checked = (r.value === value);
                });
            }
        }, 
        [QuizWizard.TYPE_SINGLE_DECISION]: { 
            validate(slide) {
                return !!slide.querySelector('input[type="radio"]:checked');    // One of the radios must be checked
            },
            extract(slide) {
                const sel = slide.querySelector('input[type="radio"]:checked'); // The value of the radio checked
                return sel ? sel.value : '';
            },
            hydrate(slide, value) {
                if (value == null) return;
                slide.querySelectorAll('input[type="radio"]').forEach(r => {
                r.checked = (r.value === value);
                });
            },
            getFinalId(slide) {
                const def = slide.dataset.defaultFinalPage || '';
                const sel = slide.querySelector('input[type="radio"]:checked');
                return sel?.dataset.link?.trim() || def;
            }
        }, 
        [QuizWizard.TYPE_MULTI_SELECT]: {
            validate(slide) {
                return slide.querySelectorAll('input[type="checkbox"]:checked').length > 0;
            },
            extract(slide) {
                return [...slide.querySelectorAll('input[type="checkbox"]:checked')].map(cb => cb.value);
            },
            hydrate(slide, values) {
                const set = new Set(Array.isArray(values) ? values : []);
                slide.querySelectorAll('input[type="checkbox"]').forEach(cb => {
                    cb.checked = set.has(cb.value);
                });
            }
        },
        [QuizWizard.TYPE_TEXT_ANSWER]: {
            validate(slide) {
                const input = slide.querySelector('input[type="text"], textarea');
                const minLen = parseInt(slide.dataset.minTextLength || '0', 10);
                return input && input.value.trim().length >= minLen;
            },
            extract(slide) {
                const input = slide.querySelector('input[type="text"], textarea');
                return input ? input.value.trim() : '';
            },
            hydrate(slide, value) {
                const input = slide.querySelector('input[type="text"], textarea');
                if (input) input.value = value ?? '';
            }
        },
        [QuizWizard.TYPE_EMAIL_COLLECTION]: {
            validate(slide) {
                const input = slide.querySelector('.quiz-email-input');
                return input && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim());
            },
            extract(slide) {
                const input = slide.querySelector('.quiz-email-input');
                return input ? input.value.trim() : '';
            },
            hydrate(slide, value) {
                const input = slide.querySelector('.quiz-email-input');
                if (input) input.value = value ?? '';
            }
        },
        [QuizWizard.TYPE_SLIDER]: {
            validate(slide) {
                return !!slide._userTouched;
            },
            extract(slide) {
                return slide.querySelector('input.slider').value;
            },
            hydrate(slide, value) {
                const input = slide.querySelector('input.slider');
                if (input) {
                    input.value = value;
                    slide._userTouched = true;
                    updateSliderBg(input);
                }
            }
        },
        [QuizWizard.TYPE_HEIGHT_WEIGHT]: {
            validate(slide) {
                return !!slide._userTouched;
            },
            extract(slide) {
                const h = slide.querySelector('#slider-height').value;
                const w = slide.querySelector('#slider-weight').value;
                return [h, lbsToKg(w)];
            },
            hydrate(slide, [h, w]) {
                slide.querySelector('#slider-height').value = h;
                slide.querySelector('#slider-weight').value = kgToLbs(w);
                slide._userTouched = true;
                updateSliderBg(slide.querySelector('#slider-height'));
                updateSliderBg(slide.querySelector('#slider-weight'));
            }
        },
        [QuizWizard.TYPE_WEIGHT]: {
            validate(slide) {
                return !!slide._userTouched;
            },
            extract(slide) {
                return lbsToKg(slide.querySelector('#slider-weight').value);
            },
            hydrate(slide, value) {
                slide.querySelector('#slider-weight').value = kgToLbs(value);
                slide._userTouched = true;
                updateSliderBg(slide.querySelector('#slider-weight'));
            }
        },
        [QuizWizard.TYPE_FINAL_PAGE]: {
            validate(slide) {
                const input = slide.querySelector('.quiz-email-input');
                return input && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim());
            }
        }
    };

    // Per-type DOM wiring
    static initPerType = {
        [QuizWizard.TYPE_TEXT_ANSWER]: function(slide) {
            slide.querySelectorAll('textarea').forEach(el => {
                el.value = '';
                el.addEventListener('input', () => {
                    el.style.height = 'auto';
                    requestAnimationFrame(() => {
                        el.style.height = el.scrollHeight + 'px';
                    });
                });
            });
        },
        [QuizWizard.TYPE_SLIDER]: function(slide) {
            const num = slide.querySelector('input[type="number"]');
            const range = slide.querySelector('input[type="range"]');
            if (!num || !range) return;
            num.value = range.value;
            updateSliderBg(range);
            range.addEventListener('input', () => {
                updateSliderBg(range);
                num.value = range.value;
                this.onInput();
            });
            num.addEventListener('input', () => {
                const v = parseFloat(num.value);
                if (!isNaN(v)) range.value = v;
                updateSliderBg(range);
            });
            num.addEventListener('change', () => {
                const min = parseFloat(range.min);
                const max = parseFloat(range.max);
                let v = parseFloat(num.value);
                if (isNaN(v)) return;
                v = Math.max(min, Math.min(max, v));
                num.value = v;
                range.value = v;
                updateSliderBg(range);
                this.onInput();
            });
        },
        [QuizWizard.TYPE_HEIGHT_WEIGHT]: function(slide) {
            initHeightWeightControls.call(this, slide);
        },
        [QuizWizard.TYPE_WEIGHT]: function(slide) {
            initHeightWeightControls.call(this, slide);
        }
    };

    // Wrap raw strategies so we can call validate()/extract() with no args
    getStrategy(slide) {
        const raw = QuizWizard.slideTypes[slide.dataset.slideType] || {};
        return {
            validate:   () => (raw.validate   || (() => true ))(slide),
            extract:    () => (raw.extract    || (() => null ))(slide),
            hydrate:    v => (raw.hydrate    || (() => {}  ))(slide, v),
            getFinalId: () => (raw.getFinalId || (() => ''  ))(slide)
        };
    }

  // --------- Initialization & lifecycle ---------

    init() {
        this.initHistory(); // enable use of browser's back/forward buttons
        this.initListeners();
        this.initUrls();
        this.initAddPageCloseHandler(); // handle quiz data submission on user leaving the page
        this.initResizeViewport(); // fix erratic behavior of Safari on iOS
        this.loadProgressAndApply(); // load progress from local storage, if available
        this.showStep(this.currentStep); // show current step
    }

    initHistory() {
        history.replaceState({quizStep:0}, '', location.href);
    }
    initListeners() {
        this.nextBtn.addEventListener('click', () => this.goNext());
        this.backBtn.addEventListener('click', () => this.goBack());
        window.addEventListener('popstate', e => this.onPopState(e));

        this.slides.forEach(slide => {
            slide.querySelectorAll('input,textarea').forEach(el => {
                el.addEventListener('input',  () => this.onInput());
                el.addEventListener('change', () => this.onInput());
            });
            slide.querySelectorAll('input[type="range"], input[type="number"]').forEach(el => {
                el.addEventListener('input', () => slide._userTouched = true);
            });
            const fn = QuizWizard.initPerType[slide.dataset.slideType];
            if (fn) fn.call(this, slide);
        });
        this.destCTA.addEventListener(
            'click', 
            event => this.handleOutboundClick(event, this.destCTA.href, QuizWizard.OUTBOUND_TYPE_SECONDARY)
        );
    }
    initUrls() {
        this.destCTA.href = addUTMParams(this.destCTA.href, this.utmSource, this.utmCampaign);
    }
    initAddPageCloseHandler() {
        window.addEventListener('pagehide', e => this.onPageHide(e)); 
    }
    initResizeViewport() {  
        if (!this.isInEditor) { // help correctly set the page size for sticky footer position calculation
            window.addEventListener('resize', this.updateVH);
            window.addEventListener('orientationchange', this.updateVH);
            this.updateVH();
        }
    }

  onInput() {
    this.validateCurrentStep();
    this.saveProgress();
  }

    // --- Fix erratic behavior of Safari on iOS ---
    updateVH() {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    showStep(step) {
        this.currentStep = step;
        const slide = this.slides[step];
        const type  = slide.dataset.slideType;

        // Show/hide slides
        this.slides.forEach((s,i) => s.classList.toggle('hidden', i!==step && !this.isInEditor));
        this.finals.forEach(s => s.classList.toggle('hidden', !this.isInEditor));
        this.destCTA.classList.remove('hidden');

        // Toggle border around active (current) slide in editor
        this.slides.forEach((s, i) => s.classList.toggle('quiz-in-editor-active', i==step && this.isInEditor));

        // Back/Next visibility & labels
        this.backBtn.classList.toggle('hidden', step===0);
        document.getElementById('quiz-back-placeholder').classList.toggle('hidden', step !== 0);
        this.nextBtn.classList.toggle('hidden',
            [QuizWizard.TYPE_SINGLE_SELECT, QuizWizard.TYPE_SINGLE_DECISION].includes(type) && this.isRequired(slide)
        );
        this.nextBtn.textContent = this.nextLabel(slide);

        // Progress, validation, persistence
        this.updateProgress();
        this.validateCurrentStep();
        this.saveProgress();
        history.replaceState({quizStep:step}, '', location.href);

        // Extras
        this.autoAdvanceOnRadio(slide);
        this.focusAutofocus(slide);
    }

    updateProgress() {
        if (!this.progressBar) return;
        const pct = ((this.currentStep+1)/this.slides.length)*100;
        this.progressBar.style.setProperty('width', pct+'%');
    }

    isRequired(slide) {
        return slide.dataset.required === 'true';
    }

    validateCurrentStep() {
        const slide = this.slides[this.currentStep];
        this.nextBtn.textContent = this.nextLabel(slide);
        if (!this.isRequired(slide)) {
            this.nextBtn.disabled = false;
            return;
        }
        const valid = this.getStrategy(slide).validate();
        this.isUserInput = this.isUserInput || valid;
        this.nextBtn.disabled = !valid;
        slide.classList.toggle('quiz-in-editor-error', this.isInEditor && !valid);
    }

    isInputOnSlideValid(slide) {
        return this.getStrategy(slide).validate();
    }

    nextLabel(slide) {
        const custom = (slide.getAttribute('data-button-next')||'').trim();
        if (custom) return custom;
        const req   = this.isRequired(slide);
        const valid = this.getStrategy(slide).validate();
        return (!req && !valid) ? 'Skip' : 'Next';
    }

    goNext() {
        const slide = this.slides[this.currentStep];
        const type  = slide.dataset.slideType;
        const strat = this.getStrategy(slide);
        if (type === QuizWizard.TYPE_EMAIL_COLLECTION && strat.validate()) {
            this.isEmailSubmitted = true;
            this.reportLeadCaptureEmail(strat.extract());
            this.klaviyoSubscribe(strat.extract());
        }
        if (this.currentStep === this.slides.length - 1) { // On quiz completion:
            this.submissionComplete = true;
            this.backBtn.disabled = true;
            this.nextBtn.disabled = true;
            this.clearProgress();
            slide.classList.add('hidden');
            this.displayFinalPage();
            return;
        }
        if (type === QuizWizard.TYPE_SINGLE_DECISION) {
            this.finalPageId = strat.getFinalId();
        }

        history.pushState({quizStep:this.currentStep}, '', location.href);
        this.currentStep++;
        this.showStep(this.currentStep);
    }

    goBack() {
        if (this.currentStep > 0) {
            history.back();
        }
    }

    displayFinalPage() {
        this.submissionComplete = true;
        if (!this.finalPageId) return;
        let finalPage = null;
        this.slides[this.currentStep].classList.add('hidden');
        (this.finalPages[this.finalPageId] || []).forEach(s => {
            s.classList.remove('hidden');
            finalPage = s;
        });
        if (finalPage) {
            this.footer.classList.add('hidden');
            document.querySelector('.quiz-progress-bar')?.classList.add('hidden');
            this.backBtn.classList.add('hidden');
            document.getElementById('quiz-back-placeholder').classList.remove('hidden');
            const strat = this.getStrategy(finalPage);
            const emailSubmissionBlock = finalPage.querySelector('.quiz-email-collection');
            if (!this.isEmailSubmitted && finalPage && emailSubmissionBlock) {
                const submitButton = finalPage.querySelector('.quiz-final-email-submit');
                const emailInput = finalPage.querySelector('.quiz-email-input');
                submitButton.disabled = true;
                emailSubmissionBlock.classList.remove('hidden');
                // Listeners
                submitButton.addEventListener('click', () => { // On email submission
                    if (strat.validate()) {
                        this.reportLeadCaptureEmail(emailInput.value);
                        this.klaviyoSubscribe(emailInput.value);
                        emailInput.disabled = true;
                        submitButton.disabled = true;
                        emailSubmissionBlock.classList.add('hidden');
                    }
                });
                emailInput.addEventListener('input', () => { // Validate email input
                    submitButton.disabled = !strat.validate();
                });
            }
            const finalButton = finalPage.querySelector('.quiz-final-button');
            finalButton.href = addUTMParams(finalButton.href, this.utmSource, this.utmCampaign);
            finalButton.addEventListener('click', event => { // On clicking the outbound link
                this.handleOutboundClick(event, finalButton.href, QuizWizard.OUTBOUND_TYPE_FINAL);
            })
        }
    }

    buildSubmissionPayload(completed = false) {
        const headers = ['Completed', 'Last step', 'email', 'URL', 'Click source'];
        const answers = [
            completed ? 'YES' : 'NO', 
            this.currentStep + 1,
            this.userEmail,
            this.outboundUrl,
            this.outboundButton
        ];
        this.slides.forEach((slide, i) => {
            const strat = this.getStrategy(slide);
            const value = strat.extract();
            if (value !== null && value !== undefined) {
                headers.push(`${i+1}: ${slide.dataset.heading || ''} [${slide.dataset.slideType}]`);
                answers.push(JSON.stringify(strat?.extract()));
            }
        });
        return { headers, answers };
    }

    async klaviyoSubscribe(email, listId = this.klaviyoListId, marketingEvent = this.klaviyoMarketingEvent, publicCompanyId = this.klaviyoCompanyId) {

        if (!email || !listId || !marketingEvent || !publicCompanyId) return;

        const res = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${publicCompanyId}`, {
            method: 'POST',
            headers: { 
                accept: 'application/vnd.api+json',
                revision: '2025-07-15',
                'content-type': 'application/vnd.api+json'
             },
            body: JSON.stringify({
            data: {
                    "type": "subscription",
                    "attributes": {
                        "custom_source": marketingEvent,
                        "profile": {
                            "data": {
                                "type": "profile",
                                "attributes": {
                                    "email": email,
                                    "subscriptions": {
                                        "email": {
                                            "marketing": {
                                                "consent": "SUBSCRIBED"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                    "relationships": {
                        "list": {
                            "data": {
                                "type": "list",
                                "id": listId
                            }
                        }
                    }
                }
            })
        });
        if (!res.ok) throw new Error(`Klaviyo error ${res.status}: ${await res.text()}`);
    }

    async reportLeadCaptureEmail (rawEmail) {
        if (QuizWizard.DEBUG) console.log (`captured email: ${rawEmail}`);
        this.userEmail = rawEmail;
        const pixelId = getPixelId();
        if (pixelId) {
            const email = normalizeEmail(rawEmail);
            fbq('init', pixelId, { em: email});
            fbq('track', 'Lead', {
                content_name: 'Quiz',
                content_category: 'quiz'
            });
        }
    }
    async reportOutboundClick (url, source = null) {
        this.outboundButton = source;
        this.outboundUrl = url;
        if (window.fbq) {
            fbq('trackCustom', 'QuizOutboundClick', {
                destination: url,
                content_name: 'Quiz',
                content_category: 'quiz'
            });
        }
    }

    handleOutboundClick(event, url, source){
        if (QuizWizard.DEBUG) console.log(`handleOutboundClick ${event}, ${url}, ${source}, ${this.WEBAPP_URL}`);
        event.preventDefault();
        this.reportOutboundClick(url, source);
        this.exitPayloadSent = true;
        this.sendPayload(this.submissionComplete);
        setTimeout(() => {
            window.location.href = url;
        }, QuizWizard.OUTBOUND_CLICK_DELAY);
    }

    sendPayload(completed = false) {
        if (!this.isUserInput) return;
        if (QuizWizard.DEBUG) console.log(`Sending quiz payload, completed = ${completed}`);
        const data = JSON.stringify(this.buildSubmissionPayload(completed));
        if (navigator.sendBeacon) {
            navigator.sendBeacon(this.WEBAPP_URL, data);
        } else {
            fetch(this.WEBAPP_URL, { method: 'POST', mode: 'no-cors', body: data, keepalive: true })
                .catch(() => {});
        }
    }

    collectStateFromSlides() {
        const state = {};
        this.slides.forEach((slide, i) => {
            state[i] = this.getStrategy(slide).extract();
        });
        return state;
    }

    applyStateToSlides(state = {}) {
        this.slides.forEach((slide, i) => {
            if (i in state) this.getStrategy(slide).hydrate(state[i]);
        });
    }

    saveProgress() {
        if (!this.SAVE_PROGRESS) return;
        try {
            localStorage.setItem(this.QUIZ_STORAGE_KEY, JSON.stringify({
                currentStep: this.currentStep,
                submissionComplete: this.submissionComplete,
                values: this.collectStateFromSlides()
            }));
        } catch {}
    }

    loadProgressAndApply() {
        if (!this.SAVE_PROGRESS) return;
        try {
            const raw = localStorage.getItem(this.QUIZ_STORAGE_KEY);
            if (!raw) return;
            const { currentStep, submissionComplete, values } = JSON.parse(raw);
            if (submissionComplete) return this.clearProgress();
            this.currentStep = Math.min(currentStep || 0, this.slides.length - 1);
            this.applyStateToSlides(values);
        } catch {}
    }
    // Return all slides to their original state, clearing all user input
    clearProgress() {
        this.slides.forEach(s => {
            delete s._userTouched;
            s.querySelectorAll('input[type="text"], input[type="number"], textarea').forEach(i => i.value='');
            s.querySelectorAll('input[type="range"]').forEach(r => {
                if (r.dataset.value) {
                    r.value = parseInt(r.dataset.value, 10);
                } else
                {
                    const avg = (parseInt(r.min, 10)+parseInt(r.max, 10))/2
                    r.value = avg;
                }
            });
        });
        this.currentStep = 0;
        if (!this.SAVE_PROGRESS) return;
        try { localStorage.removeItem(this.QUIZ_STORAGE_KEY); } catch {}
    }

    onPopState(event) { // handling the history.back() event, such as right swipe on mobile 
        if (event.state?.quizStep != null) {
            if (QuizWizard.DEBUG) console.log(`quizStep: ${event.state.quizStep}`);
            this.currentStep = event.state.quizStep;
            this.showStep(this.currentStep);
        }
    }

    onPageHide(event) { // When the user quits the page, we send the quiz data (sendPayload method)
        if (event.persisted || this.exitPayloadSent ) return;
        this.exitPayloadSent = true;
        this.sendPayload(false);
    }

    autoAdvanceOnRadio(slide) { // If the slide is the single select / decision, then proceed when the user selects a choice
        let done = false;
        const type = slide.dataset.slideType;
        if (![QuizWizard.TYPE_SINGLE_SELECT, QuizWizard.TYPE_SINGLE_DECISION].includes(type)) return;
        const radios = slide.querySelectorAll('input[type="radio"]');

        // Clean up previous handler if any
        if (slide._autoAdvanceHandler) {
            slide.querySelectorAll('input[type="radio"]').forEach(r => {
                r.removeEventListener('change', slide._autoAdvanceHandler);
                r.removeEventListener('click', slide._autoAdvanceHandler);
            });
        }

        const handler = () => {
            if (done) return;
            done = true;
            setTimeout(() => this.goNext(), 300); // slight delay to let users see that their choice has been selected
        };

        // Store for future removal
        slide._autoAdvanceHandler = handler;

        radios.forEach(r => {
            r.addEventListener('change', handler, { once: true });
            r.addEventListener('click', handler, { once: true });
        });
    }
    /**
     * The first item with the 'autofocus' class gets focus. Do not assign this class to items that 
     * do need to get focus automatically. 
     * 
     * For example, we don't set focus to the email input field because appearing keyboard on mobile 
     * devices (or email selection dropdown on desktops) gets half a text covered, and also scrolls 
     * past the main content.
     */
    focusAutofocus(slide) { 
        const el = slide.querySelector('.autofocus');
        if (el) el.focus();
    }
}



// --- Helper services ---
function updateSliderBg(el) {
    const min = parseFloat(el.min) || 0;
    const max = parseFloat(el.max) || 100;
    const val = parseFloat(el.value) || 0;
    const pct = ((val - min) / (max - min)) * 100;
    el.style.setProperty('--percent', pct + '%');
}
function cmToFeetInches(cm) {
    const total = cm / 2.54;
    return { feet: Math.floor(total / 12), inches: Math.round(total % 12) };
}
function feetInchesToCm(feet, inches) {
    return Math.round(((parseInt(feet) || 0) * 12 + (parseInt(inches) || 0)) * 2.54);
}
function kgToLbs(kg) {
    return Math.round(kg * 2.20462262);
}
function lbsToKg(lbs) {
    return Math.round(lbs / 2.20462262);
}
function addUTMParams(urlString, utmSource, utmCampaign) {
  try {
    const url = new URL(urlString);

    const params = url.searchParams;

    if (utmSource) params.set('utm_source', utmSource);
    if (utmCampaign) params.set('utm_campaign', utmCampaign);

    return url.toString();
  } catch (e) {
    if (QuizWizard.DEBUG) {
        console.error(`addUTMParams exception: ${e.message}`);
        console.error(e.stack);
    }   
    return urlString; 
  }
}
function normalizeEmail(email) {
  return String(email).trim().toLowerCase();
}
function getPixelId() {
  if (window.fbq && window.fbq.getState) {
    const state = window.fbq.getState();
    if (state && state.pixels && state.pixels.length > 0) {
      return state.pixels[0].id; // first pixel ID on the page
    }
  }
  return null;
}

// Full implementation of height/weight controls
function initHeightWeightControls(slide) {
    const weightOnly = slide.dataset.slideType === QuizWizard.TYPE_WEIGHT;
    const step = slide.dataset.step;
    const unitSwitch = slide.querySelectorAll(`input[name="unit-system-${step}"]`);
    const metricInputs = slide.querySelectorAll('.input-metric');
    const imperialInputs = slide.querySelectorAll('.input-imperial');
    const feetInput = slide.querySelector('#height-feet');
    const inchesInput = slide.querySelector('#height-inches');
    const cmInput = slide.querySelector('#height-cm');
    const kgInput = slide.querySelector('#weight-kg');
    const lbsInput = slide.querySelector('#weight-lbs');
    const cmSlider = slide.querySelector('#slider-height');
    const lbsSlider = slide.querySelector('#slider-weight');

    // Init
    let currentUnitSystem = 'imperial';
    onMetricInputChange();
    updateDisplay();

    // Listeners
    unitSwitch.forEach(input => {
        input.addEventListener('change', () => {
            currentUnitSystem = input.value;
            updateDisplay();
        });
    });
    metricInputs.forEach(input => {
        input.addEventListener('change', () => {
            if (input.type === 'number') {
            onMetricInputChange();
            updateDisplay();
            }
        });
    });
    imperialInputs.forEach(input => {
        input.addEventListener('change', () => {
            if (input.type === 'number') {
            onImperialInputChange(true);
            updateDisplay();
            }
        });
    });
    slide.querySelectorAll('input[type="range"]').forEach(el => {
        el.addEventListener('input', () => {
            if (!weightOnly) cmInput.value = parseFloat(cmSlider.value);
            kgInput.value = lbsToKg(lbsSlider.value);
            const lbs = parseFloat(lbsSlider.value);
            onMetricInputChange(false);
            lbsInput.value = lbs;
            updateDisplay();
        });
    });

    // Helpers
    function onImperialInputChange(updateSliders = true) {
    let cm;
    if (!weightOnly) cm = feetInchesToCm(feetInput.value, inchesInput.value);
    const kg = lbsToKg(lbsInput.value);
    if (updateSliders) {
        if (!weightOnly) cmSlider.value = cm;
        lbsSlider.value = lbsInput.value;
    }
    if (!weightOnly) cmInput.value = cm;
    kgInput.value = kg;
    }
    function onMetricInputChange(updateSliders = true) {
    if (updateSliders) {
        if (!weightOnly) cmSlider.value = cmInput.value;
        lbsSlider.value = kgToLbs(kgInput.value);
    }
    if (!weightOnly) {
        const { feet, inches } = cmToFeetInches(parseInt(cmSlider.value));
        feetInput.value = feet;
        inchesInput.value = inches;
    }
    lbsInput.value = kgToLbs (kgInput.value);
    }
    function updateDisplay() {
    metricInputs.forEach (el => el.classList.toggle('hidden', currentUnitSystem === 'imperial'));
    imperialInputs.forEach (el => el.classList.toggle('hidden', currentUnitSystem !== 'imperial'));
    if (!weightOnly) updateSliderBg(cmSlider);
    updateSliderBg(lbsSlider);
    }
}